import React from 'react'
import './styles/index.scss'
import { useSelector } from 'react-redux'
import Icon from 'icons/Icon'

const NoDataAvailable = ({ errorMessage }) => {
  const { languageData } = useSelector((state) => state.language)

  return (
    <>
      <div className='not-found-box'>
        <Icon name='no-data' className='fa-shake' />
        <div className='text-box'>
          <h5 className='title-text'>{errorMessage || languageData?.noDataFound} !</h5>
        </div>
      </div>
    </>
  )
}

export default NoDataAvailable
